export const blue = "#000066";
export const darkBlue = "#00074a";
export const gold = "#C7A86E";
export const gold2 = "#e6dabb";
